import { ActionType, getType } from 'typesafe-actions';

import * as config from '../../actionCreators/config';

export default function (
  state: boolean = true,

  action: ActionType<typeof config>,
): boolean {
  switch (action.type) {
    case getType(config.setEnableGuestOrdering): {
      const { value } = action.payload;
      return Boolean(value);
    }
    default:
      return state;
  }
}
